import { LOCALES, hostname } from '@web3/base-utils';
// 在url上的路径base
export const SYSTEM_SYMBOL = 'web3/airdrop';
/** 系统标识 */
export const LanguagePack = 'web3-airdrop';

export const defaultLocale = 'en';

const host = hostname();
/* eslint-disable bybit/no-static-domain */
const isHKSite = host.endsWith('bybit.com.hk');

export const languageProject = 'nft-dex';

export const langList = LOCALES;

//
export const supportLocale = langList.map((item) => item.value);

// 网站默认语言
export const lang = isHKSite ? 'zh-HK' : 'en';
